import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICustomerXPaymentTerm } from "src/models/General/PaymentTerm.models";

interface CustomerXPaymentTermState {
  customerXPaymentTerm: ICustomerXPaymentTerm[];
  customerXPaymentTermToEdit: ICustomerXPaymentTerm | null;
}

const initialState: CustomerXPaymentTermState = {
  customerXPaymentTerm: [],
  customerXPaymentTermToEdit: null,
};

const customerXPaymentTermSlice = createSlice({
  name: "CustomerXPaymentTerm",
  initialState,
  reducers: {
    setCustomerXPaymentTermList: (
      state,
      action: PayloadAction<ICustomerXPaymentTerm[]>
    ) => {
      state.customerXPaymentTerm = action.payload;
    },
    concatListCustomerXPaymentTerm: (
      state: CustomerXPaymentTermState,
      action: PayloadAction<ICustomerXPaymentTerm[]>
    ) => {
      state.customerXPaymentTerm = [
        ...state.customerXPaymentTerm.concat(action.payload),
      ];
    },
    setCustomerXPaymentTermToEdit: (
      state,
      action: PayloadAction<ICustomerXPaymentTerm | null>
    ) => {
      state.customerXPaymentTermToEdit = action.payload;
    },
    addCustomerXPaymentTerm: (
      state,
      action: PayloadAction<ICustomerXPaymentTerm>
    ) => {
      state.customerXPaymentTerm.push(action.payload);
    },
    updateCustomerXPaymentTerm: (
      state,
      action: PayloadAction<ICustomerXPaymentTerm>
    ) => {
      let itemIndex = state.customerXPaymentTerm.findIndex(
        item =>
          item.customerXPaymentTermId === action.payload.customerXPaymentTermId
      );
      if (itemIndex !== -1)
        state.customerXPaymentTerm[itemIndex] = action.payload;
    },
    deleteCustomerXPaymentTerm: (state, action: PayloadAction<number>) => {
      const newArray = state.customerXPaymentTerm.filter(
        item => item.customerXPaymentTermId !== action.payload
      );
      state.customerXPaymentTerm = newArray;
    },
  },
});

export const {
  setCustomerXPaymentTermList,
  concatListCustomerXPaymentTerm,
  setCustomerXPaymentTermToEdit,
  addCustomerXPaymentTerm,
  updateCustomerXPaymentTerm,
  deleteCustomerXPaymentTerm,
} = customerXPaymentTermSlice.actions;

export default customerXPaymentTermSlice.reducer;
